import { AnalyticsDispatcher } from '../../internal/AnalyticsDispatcher';
import { withIdentity as higherOrder } from '../../extenders';
function withIdentity(key, value) {
    return higherOrder(key, value)(this);
}
AnalyticsDispatcher.prototype.withIdentity = withIdentity;
//# sourceMappingURL=withIdentity.js.map